import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ShoppingCart, Shield, Clock, Heart, Check } from 'lucide-react';
const items = [{
  icon: BookOpen,
  title: 'Guía Principal',
  description: 'Protocolos paso a paso para Fiebre, Cólicos, Dentición y Congestión.'
}, {
  icon: ShoppingCart,
  title: 'Lista de Compras en USA',
  description: 'Dónde conseguir los 7 indispensables en Target, Whole Foods o Amazon.'
}, {
  icon: Shield,
  title: 'Matriz de Dilución Segura',
  description: 'Las dosis exactas por mes de edad para evitar irritaciones.'
}, {
  icon: Clock,
  title: 'Checklist de Emergencia',
  description: 'Qué hacer en los primeros 10 minutos de cada crisis.'
}, {
  icon: Heart,
  title: "Guía de 'Semáforo de Síntomas'",
  description: 'Para saber con total certeza cuándo quedarte en casa y cuándo llamar al pediatra.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-133">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-135">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-136">
            Lo que recibes
          </h2>
          <div className="w-24 h-1 bg-sage/40 mx-auto rounded-full" data-id="element-137"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-138">
          {items.map((item, index) => <motion.div key={index} variants={itemVariants} className={`bg-cream p-8 rounded-2xl border border-cream-dark/50 shadow-sm hover:shadow-md transition-shadow duration-300 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-139">
              <div className="w-12 h-12 rounded-full bg-sage/10 flex items-center justify-center mb-6" data-id="element-140">
                <item.icon className="w-6 h-6 text-sage" data-id="element-141" />
              </div>
              <h3 className="text-xl font-bold mb-3 font-playfair flex items-center gap-2" data-id="element-142">
                {item.title}
              </h3>
              <p className="text-brown-body leading-relaxed" data-id="element-143">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}